import React, { useState } from 'react';
import { auth, db } from '../../config/firebaseConfig';
import { NavLink, useNavigate } from 'react-router-dom';
import { Form, Button, Container, Row, Col, Spinner, Toast, ToastContainer } from 'react-bootstrap';
import '@animxyz/core';
import { XyzTransition } from '@animxyz/react';

export default function SignUp() {
  const [name, setName] = useState('');
  const [firstName, setFirstName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [city, setCity] = useState('');
  const [zipCode, setZipCode] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const [loading, setLoading] = useState(false);
  const [passIsVisible, setPassIsVisible] = useState(false);
  const [passIsVisibleConfirm, setPassIsVisibleConfirm] = useState(false);

  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastVariant, setToastVariant] = useState('success');

  const navigate = useNavigate();

  const triggerToast = (message, variant = 'success') => {
    setToastMessage(message);
    setToastVariant(variant);
    setShowToast(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      return triggerToast('Mots de passe différents.', 'danger');
    }

    if (password.length < 6) {
      return triggerToast('6 caractères minimum.', 'danger');
    }

    try {
      setLoading(true);

      // 1. Création du compte utilisateur dans Firebase Auth
      const userCredential = await auth.createUserWithEmailAndPassword(email, password);
      const user = userCredential.user;

      // 2. Mise à jour du profil de base de l'utilisateur (Optionnel mais recommandé pour le nom complet)
      await user.updateProfile({
        displayName: `${firstName} ${name}`
      });

      // 3. Enregistrement du Pseudo et de la Ville dans Cloud Firestore
      // On utilise l'UID unique généré par Firebase comme ID de document
      await db.collection('users').doc(user.uid).set({
        name: name,
        firstName: firstName,
        email: email,
        city: city,
        zipCode: zipCode,
        createdAt: new Date()
      });

      triggerToast("Inscription effectuée avec succès !", 'success');

      setTimeout(() => {
        navigate('/');
      }, 2000);

      setName('');
      setFirstName('');
      setEmail('');
      setCity('');
      setZipCode('');
      setPassword('');
      setConfirmPassword('');
    } catch (err) {
      // Traduction des erreurs courantes de Firebase
      if (err.code === 'auth/email-already-in-use') {
        triggerToast('Cette adresse email est déjà utilisée.', 'danger');
      } else if (err.code === 'auth/invalid-email') {
        triggerToast('L’adresse email n’est pas valide.', 'danger');
      } else {
        triggerToast('Une erreur est survenue lors de l’inscription.', 'danger');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className='connexion wrapper mt-5'>
      <XyzTransition appear xyz='fade flip-down stagger delay-4 duration-15'>
        <legend>
          <h3 className='d-flex justify-content-center'>Inscription</h3>
        </legend>
      </XyzTransition>

      <XyzTransition
        appear
        xyz='fade small out-down delay-2 duration-10 appear-stagger ease-out-back'
      >
        <Form autoComplete='off' onSubmit={handleSubmit}>
          <Form.Group controlId='name'>
            <Form.Label>Nom:</Form.Label>
            <div className='input-group mb-1'>
              <Form.Control
                type='text'
                value={name}
                required
                autoComplete='off'
                onChange={(e) => setName(e.target.value)}
              />
            </div>
          </Form.Group>

          <Form.Group controlId='firstName'>
            <Form.Label>Prénom:</Form.Label>
            <div className='input-group mb-3'>
              <Form.Control
                type='text'
                value={firstName}
                required
                autoComplete='off'
                onChange={(e) => setFirstName(e.target.value)}
              />
            </div>
          </Form.Group>

          <Form.Group controlId='email'>
            <Form.Label>Email:</Form.Label>
            <div className='input-group mb-3'>
              <Form.Control
                type='email'
                value={email}
                pattern='[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$'
                required
                autoComplete='off'
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
          </Form.Group>

          <Row>
            <Col md={8} xs={7}>
              <Form.Group controlId='city'>
                <Form.Label>Ville:</Form.Label>
                <div className='input-group mb-3'>
                  <Form.Control
                    type='text'
                    value={city}
                    required
                    autoComplete='off'
                    onChange={(e) => setCity(e.target.value)}
                  />
                </div>
              </Form.Group>
            </Col>

            <Col md={4} xs={5}>
              <Form.Group controlId='zipCode'>
                <Form.Label>Code postal:</Form.Label>
                <div className='input-group mb-3'>
                  <Form.Control
                    type='text'
                    maxLength={5}
                    value={zipCode}
                    required
                    autoComplete='off'
                    onChange={(e) => {
                      const val = e.target.value.replace(/\D/g, '');
                      setZipCode(val)
                    }
                    }
                  />
                </div>
              </Form.Group>
            </Col>
          </Row>

          <Form.Group controlId='password'>
            <Form.Label>Mot de passe:</Form.Label>
            <div className='input-group mb-3'>
              <Form.Control
                value={password}
                type={passIsVisible ? 'text' : 'password'}
                pattern='(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}'
                title='Doit contenir au moins un nombre, une majuscule et une minuscule, et 8 caractères ou plus.'
                required
                autoComplete='off'
                onChange={(e) => setPassword(e.target.value)}
              />

              <span
                className='input-group-text material-icons material-symbols-outlined'
                style={{ cursor: 'pointer' }}
                onClick={() => setPassIsVisible(!passIsVisible)}
              >
                {passIsVisible ? 'visibility' : 'visibility_off'}
              </span>
            </div>
          </Form.Group>

          <Form.Group controlId='confirmPassword' className='mb-4'>
            <Form.Label>Confirmer le mot de passe:</Form.Label>
            <div className='input-group mb-3'>
              <Form.Control
                value={confirmPassword}
                type={passIsVisibleConfirm ? 'text' : 'password'}
                required
                autoComplete='off'
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
              <span
                className='input-group-text material-icons material-symbols-outlined'
                onClick={() =>
                  setPassIsVisibleConfirm(!passIsVisibleConfirm)}
              >
                {passIsVisibleConfirm ? 'visibility' : 'visibility_off'}
              </span>
            </div>
          </Form.Group>

          <div className="d-grid gap-2">
            <Button variant='primary' type='submit' disabled={loading} className='submit mt-1'>
              {loading ? (
                <React.Fragment>
                  <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2" />
                  Inscription en cours...
                </React.Fragment>
              ) : "Inscription"}
            </Button>
          </div>

          <div className='d-flex justify-content-end mt-2'>
            <NavLink to='/connexion' className='text-decoration-none log-out'>
              Déjà membre ? Connectez-vous
            </NavLink>
          </div>
        </Form>
      </XyzTransition>
      <ToastContainer position="bottom-end" className="py-5" style={{ position: 'fixed', zIndex: 9999 }}>
        <Toast
          onClose={() => setShowToast(false)}
          show={showToast}
          delay={3000}
          autohide
          bg={toastVariant}
          className="text-white shadow"
        >
          <div className="d-flex align-items-center p-2">
            <Toast.Body className="d-flex justify-content-between align-items-center py-2 px-3">
              <i className="material-icons me-2" style={{ verticalAlign: 'middle' }}>
                {toastVariant === 'success' ? 'check_circle' : 'error'}
              </i>
              <span className="fw-medium">{toastMessage}</span>
            </Toast.Body>
            <Button
              variant="close"
              ariant-white="true"
              className="me-2 m-auto btn-close-white"
              onClick={() => setShowToast(false)}
              aria-label="Fermer"
            />
          </div>
        </Toast>
      </ToastContainer>
    </Container>
  );
}
